import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import _ from 'lodash/fp';
import { useHistory } from 'react-router-dom';
import { MY_PROFILE, UPDATE_PROFILE } from '@api';
import { useQuery, useMutation } from '@apollo/client';
import Spinner from '../Spinner';
import ManageProfileNotice from '../ManageProfileNotice';
import config from '@config';
import { Icon } from '@assets';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToggleButton } from '../shared/sparkLib/ToggleButton';

export default function AdminProfile() {
  const { register, handleSubmit, errors } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });
  const {
    data: profileData,
    loading: ProfileLoading,
    refetch: profileRefetch,
  } = useQuery(MY_PROFILE, {
    onCompleted: (data) => {
      if (data.myProfile) {
        //setuser(data.myProfile);
      } else {
        toast('Profile not found', { type: 'error' });
      }
    },

    onError: (error) => {
      console.log(error + '>>>>> ERROR >>>>>');
      toast('Profile not found', { type: 'error' });
    },
  });

  const [user, setuser] = useState([]);
	const [is2FA, setIs2FA] = useState(true);

  const [userProfileUpdate, { data, loading, error }] = useMutation(
    UPDATE_PROFILE,
    {
      onCompleted: (data) => {
        if (
          data.userProfileUpdate.errors &&
          data.userProfileUpdate.errors.length > 0
        ) {
          data.userProfileUpdate.errors.map((err) =>
            toast(err, { type: 'error' })
          );
        } else {
          profileRefetch();
          toast(data.userProfileUpdate.message, { type: 'success' });
        }
      },
      onError: (e) => {
        console.log(e, 'updated profile ON ERROR');
      },
    }
  );
  useEffect(() => {
    if (profileData) {
			setuser(profileData.myProfile);
			setIs2FA(profileData.myProfile.otpRequiredForLogin);
		}

  }, [profileData]);
  const history = useHistory();

  const onSubmit = (data, e) => {
    userProfileUpdate({
      variables: {
        email: data.email,
        phoneNo: data.phoneNo,
        firstName: data.firstName,
        lastName: data.lastName,
				otpRequiredForLogin: is2FA
      },
    });
  };

  function changeUserDetail(e) {
    const { name, value } = e.target;
    setuser({ ...user, [name]: value });
  }

  return (
    <>
      {ProfileLoading && <Spinner />}
      <Container className='py-5 text-center'>
        <Row>
          <Col md='12'>
            <h2>User Profile</h2>
          </Col>

          <Col
            lg={{ size: 6, offset: 3 }}
            md={{ size: 8, offset: 2 }}
            className='text-left mt-3 mt-md-5 inputs-icons'
          >
            <ManageProfileNotice />
            <Form className='form' onSubmit={handleSubmit(onSubmit)}>
              <FormGroup>
                <Label for='firstName'>First Name</Label>
                <InputGroup>
                  <InputGroupText>
                    <Icon icon='user' />
                  </InputGroupText>
                  <Input
                    type='text'
                    name='firstName'
                    onChange={changeUserDetail}
                    defaultValue={user.firstName}
                    autoComplete='off'
                    innerRef={register({
                      required: true,
                    })}
                  />
                </InputGroup>
                {_.get('firstName.type', errors) === 'required' && (
                  <p className='input-error'>* First Name required.</p>
                )}
              </FormGroup>
              <FormGroup>
                <Label for='lastName'>Last Name</Label>
                <InputGroup>
                  <InputGroupText>
                    <Icon icon='user' />
                  </InputGroupText>
                  <Input
                    type='text'
                    name='lastName'
                    onChange={changeUserDetail}
                    defaultValue={user.lastName}
                    autoComplete='off'
                    innerRef={register({
                      required: true,
                    })}
                  />
                </InputGroup>
                {_.get('lastName.type', errors) === 'required' && (
                  <p className='input-error'>* Last Name required.</p>
                )}
              </FormGroup>
              <FormGroup>
                <Label for='clientEmail'>Email</Label>
                <InputGroup>
                  <InputGroupText>
                    <Icon icon='envelope' />
                  </InputGroupText>
                  <Input
                    type='text'
                    placeholder='Email'
                    name='email'
                    onChange={changeUserDetail}
                    defaultValue={user.email}
                    autoComplete='off'
                    innerRef={register({
                      required: true,
                      pattern: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
                    })}
                  />
                </InputGroup>
                {_.get('email.type', errors) === 'required' && (
                  <p className='input-error'>* Email required.</p>
                )}
                {_.get('email.type', errors) === 'pattern' && (
                  <p className='input-error'>* Invalid Email.</p>
                )}
              </FormGroup>
              <FormGroup>
                <Label for='clientPhone'>Phone</Label>
                <InputGroup>
                  <InputGroupText>
                    <Icon icon='phone' />
                  </InputGroupText>
                  <Input
                    type='text'
                    name='phoneNo'
                    maxLength='10'
                    onChange={changeUserDetail}
                    defaultValue={user.phoneNo}
                    autoComplete='off'
                    innerRef={register({
                      required: true,
                      minLength: 10,
                    })}
                  />
                </InputGroup>
                {_.get('phoneNo.type', errors) === 'required' && (
                  <p className='input-error'>* Phone required.</p>
                )}
                {_.get('phoneNo.type', errors) === 'minLength' && (
                  <p className='input-error'>* Phone should be 10 digit.</p>
                )}
              </FormGroup>
							<FormGroup>
								<InputGroup className='align-items-center pt-2'>
									<Label check>Two Factor Authentication </Label>&nbsp;&nbsp;&nbsp;
									<ToggleButton
										selected={is2FA}
										firstOption='ON'
										secondOption='OFF'
										width='85px'
										rounded
										toggleSelected={() => {
											setIs2FA(!is2FA);
										}}
									/>
								</InputGroup>
							</FormGroup>
							{ user.apiKey && 
								<FormGroup className='inputs-icons'>
									<Label for='phoneNo'>API Key</Label>
									<InputGroup>
										<InputGroupText className='pointer'>
											<Icon icon='copy' onClick={() => navigator.clipboard.writeText(user.apiKey)}/>
										</InputGroupText>
										<Input
											type='text'
											name='licenseNo'
											value={user.apiKey}
										/>
									</InputGroup>
								</FormGroup>
							}
              <FormGroup className='inputs-icons'>
                <Label for='referralUrl'>Referral Link</Label>
                <InputGroup>
                  <span style={{ paddingTop: '7px', fontSize: "medium"}}> {config.url.WEB_DOMAIN}signup?code={user.slug}</span>
                  <Icon icon='copy' size="lg" color="blue" className="ml-2 mt-2 cursor-pointer" onClick={() => navigator.clipboard.writeText(`${config.url.WEB_DOMAIN}signup?code=${user.slug}`)}/>
                </InputGroup>
              </FormGroup>
              <Row>
                <Col md='12' className='text-center'>
                  <Button color='primary' className='button-dashboard'>
                    Update
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}
